import { APIUtils, Config, getMTrackConsentData } from '@vm/omega-shared-component-webapp';

export const constructGetProductApiUrl = (productId: string) => APIUtils.buildPath(`${Config.get('microservice_base_url_api')}${Config.get('endpoints.get_products_product')}/`, { product_id: productId });

type GetProductListParams = { rowsPerPage?: number; pageNumber?: number };
export const constructGetProductListApiUrl = (params?: GetProductListParams) => {
  const url = `${Config.get('microservice_base_url_api')}${Config.get('endpoints.get_products')}/`;
  return url;
  // Note: we don't use the params yet so commenting out now
  // const { rowsPerPage, pageNumber } = params;
  // if (!rowsPerPage || !pageNumber) {
  //   return url;
  // }
  // const urlSearchParams = new URLSearchParams({
  //   ...(rowsPerPage ? { rowsPerPage: rowsPerPage.toString() } : {}),
  //   ...(pageNumber ? { pageNumber: pageNumber.toString() } : {}),
  // });
  // const urlSearchParamsString = urlSearchParams.toString();
  // return url + '?' + urlSearchParamsString;
};

export const getMarketplaceProduct = async (productId: string) =>
  APIUtils.withAuth(({ headers }) =>
    fetch(constructGetProductApiUrl(productId), {
      method: 'GET',
      headers,
    }),
  );

export const getMarketplaceProductList = async (params?: GetProductListParams) =>
  APIUtils.withAuth(({ headers }) =>
    fetch(constructGetProductListApiUrl(params), {
      method: 'GET',
      headers,
    }),
  );

export const getMarketplaceMTrackConsentData = async () => await getMTrackConsentData();
